// @flow
import React, { Fragment } from 'react';

export const DefaultComponent = (piece: Object) => <Fragment>{piece.type}</Fragment>;
